import { render } from "./SearchForm.vue?vue&type=template&id=65e73c26"
import script from "./SearchForm.vue?vue&type=script&lang=ts"
export * from "./SearchForm.vue?vue&type=script&lang=ts"
script.render = render

export default script